import React from "react";
import { css } from "@emotion/react";
import { theme } from "../../utils/global-styles/theme";
import { currentLocation } from "../../utils/services/methods";

const CollapseIcon = () => {
  return (
    <svg
      css={css`
        margin-left: 0.5em;
      `}
      width="10px"
      height="10px"
      viewBox="0 0 13 8"
      className={"my-dashboard-svg"}
    >
      <g
        id="Course-Detail"
        stroke={
          currentLocation()?.includes("/dashboard")
            ? theme.colors.primary
            : theme.colors.main
        }
        strokeWidth="2"
        fillRule="evenodd"
      >
        <g
          id="Ian-Version"
          transform="translate(-738.000000, -1955.000000)"
          fillRule="nonzero"
        >
          <path
            d="M741.310934,1953.3157 C740.896355,1953.73482 740.896355,1954.41186 741.310934,1954.83097 L745.435459,1959.00068 L741.310934,1963.17038 C740.896355,1963.5895 740.896355,1964.26654 741.310934,1964.68566 C741.725513,1965.10478 742.395216,1965.10478 742.809795,1964.68566 L747.689066,1959.75294 C748.103645,1959.33382 748.103645,1958.65679 747.689066,1958.23767 L742.809795,1953.30495 C742.405847,1952.89658 741.725513,1952.89658 741.310934,1953.3157 Z"
            id="Path"
            transform="translate(744.500000, 1959.000000) rotate(90.000000) translate(-744.500000, -1959.000000) "
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default CollapseIcon;
